/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useRef, useState } from 'react';
import {
  Button, ButtonGroup, Content, Dialog, DialogTrigger, Divider, Flex, Footer, Heading,
} from '@adobe/react-spectrum';
import {
  JSONFormsCore, JSONFormsReact, Loader,
  ReduxStore,
} from '@apollo/dynamic-form';
import Alert from '@spectrum-icons/workflow/Alert';
import _ from 'lodash';
import ReCaptcha from 'react-google-recaptcha';
import { toast, ToastContainer } from 'react-toastify';
import api from '../../../api/directoryApi';
import notify from '../../../util/displayToastNotification';
import { actionConfig } from '../Config/actionConfig';

const { rankWith, uiTypeIs } = JSONFormsCore;
const { JsonFormsDispatch, useJsonForms } = JSONFormsReact;

export const ContactUsRendererTester = rankWith(4, uiTypeIs('ContactUsModal'));

function ContactUsRenderer({ path }) {
  const [loader, setLoader] = useState(false);
  const jsonFormContext = useJsonForms();
  const { core, cells, renderers } = useJsonForms();
  const recaptchaRef = useRef();
  const {
    actionType, companyDetails, isOpen, handleContactUsClear, programPath, isMobile,
  } = jsonFormContext?.config.dynamicData?.data || {};

  const {
    title, actionButtonSaveText, actionButtonCancelText, jsonConfig,
  } = actionConfig[actionType] || {};

  const clearData = () => {
    ReduxStore.getState().reduxState.formContextState.setFormData({}, false);
    handleContactUsClear();
  };

  const onContactSubmit = async (formData, captcharesponse, close) => {
    const contactObject = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phoneNumber,
      country: formData.country,
      company: formData.company,
      solution: formData.solution,
      typeOfQuery: formData.typeOfQuery,
      message: formData.message,
      'g-recaptcha-token': captcharesponse,
    };
    // dispatch({ type: SUBMIT_FORM, payload: contactObject });
    try {
      setLoader(true);
      const result = await api.post(
        `/v1/${programPath}/partner/${companyDetails.id}/customer-inquiry`,
        contactObject,
        {
          headers:
          {
            'x-api-key': window.directoryConfig.adobeIO.apiKey,
          },
        },
      );

      if (result.status === 200) {
        // dispatch(reset('contactForm'));
        setLoader(false);
        clearData();
        close();
        notify({
          type: 'success-formSubmit',
          textPath: 'partner_finder.contactForm.submit_success',
          partnerName: companyDetails.name,
          autoDismissable: true,
        });
      }
    } catch (err) {
      setLoader(false);
      toast.error('Error: There was a problem sending your message to the partner. Please refresh the page or try again later.', {
        icon: <Alert />,
        hideProgressBar: true,
        autoClose: 10000,
        className: 'error-toast',
        bodyClassName: 'toast-body',
      });
      // Log to the console.
      window.console.error('Error: Problem submitting contact form data, API call failed.', err);
      // Tell New Relic about it
      if (window.newrelic) {
        window.newrelic.noticeError(
          err.message,
          {
            page: 'Detail Page',
            section: 'Contact Form',
            api: `/v1/${programPath}/partner/${companyDetails.id}/customer-inquiry`,
          },
        );
      }
    }
  };

  const executeRecaptcha = async (ref, close) => {
    try {
      const token = await ref.current.executeAsync();
      // If we get a token, submit the request.
      if (token) {
        onContactSubmit(core.data, token, close);
      }
    } catch (err) {
      // Log the error
      if (window.newrelic) {
        window.newrelic.noticeError(
          err.message,
          {
            page: 'Detail View',
            section: 'Contact Form - Recaptcha',
            api: `/v1/${programPath}/partnerlead`,
          },
        );
      }
    }
  };
  const handleSave = (close) => {
    if (_.size(core.errors)) {
      toast.error('Error: Please fill out all the required fields.', {
        icon: <Alert />,
        hideProgressBar: true,
        autoClose: 10000,
        className: 'error-toast',
        bodyClassName: 'toast-body',
      });
      ReduxStore.getState().reduxState.formContextState.setFormData(core.data, true);
    } else { executeRecaptcha(recaptchaRef, close); }
  };

  return (
    <DialogTrigger type={isMobile ? 'fullscreenTakeover' : 'modal'} isOpen={isOpen}>
      <div />
      {(close) => (
        <Dialog width="fit-content" height="fit-content" margin="auto" UNSAFE_style={{ overflowY: 'auto' }}>
          <Heading UNSAFE_style={{ marginTop: isMobile ? '70px' : '0px' }}>{`${title} ${companyDetails?.name}`}</Heading>
          <Divider UNSAFE_style={{ background: '#222222' }} />
          <Content>
            {loader && <Loader fullScreen />}
            <ToastContainer position="top-center" />
            <JsonFormsDispatch
              renderers={renderers}
              cells={cells}
              uischema={jsonConfig?.options.uischema}
              schema={jsonConfig?.options.schema}
              enabled
              path={path}
              data={{}}
              visible
            />
          </Content>
          <ButtonGroup UNSAFE_style={{ paddingLeft: '0px', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-end' : 'flex-start' }}>
            <Footer UNSAFE_style={{
              textAlign: 'center',
              color: '#bcbcbc',
              fontSize: '12px',
              marginTop: isMobile ? '0px' : '40px',
              marginRight: isMobile ? '0px' : '30px',
              paddingTop: '0px',
              whiteSpace: 'break-spaces',
            }}
            >
              {'Protected by reCAPTCHA and subject to the Google '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: '#1473e6' }}>Privacy Policy</a>
              {' and '}
              <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: '#1473e6' }}>Terms of Service</a>
              .
            </Footer>
            {isMobile && (
            <div style={{
              textAlign: 'center',
              color: '#bcbcbc',
              fontSize: '12px',
              marginBottom: '40px',
              paddingTop: '0px',
            }}
            >
              {'Protected by reCAPTCHA and subject to the Google '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: '#1473e6' }}>Privacy Policy</a>
              {' and '}
              <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: '#1473e6' }}>Terms of Service</a>
              .
            </div>
            ) }
            <Flex direction="row" alignItems="center" gap={20}>
              <Button variant="secondary" onPress={() => { clearData(); close(); }}>{actionButtonCancelText || 'Cancel'}</Button>
              <Button variant="accent" UNSAFE_style={{ margin: '0px' }} onPress={() => { handleSave(close); }}>{actionButtonSaveText || 'Add'}</Button>
              <ReCaptcha
                ref={recaptchaRef}
                size="invisible"
                sitekey={window.recaptchaOptions?.sitekey}
                onChange={() => {}}
                style={{ display: 'none' }}
              />
            </Flex>

          </ButtonGroup>
        </Dialog>
      )}
    </DialogTrigger>
  );
}

export default ContactUsRenderer;
